import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';

export const AffiliateProductContainer = styled(Container)(({ theme }) => ({
  color: theme.palette.black80.main,
  padding: theme.spacing(0, 6),
  marginTop: theme.spacing(12),
  gap: theme.spacing(12),
}));

export const SelectedOfferContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(12),
}));
